/* eslint-disable react/jsx-boolean-value */
import ReactECharts from 'echarts-for-react';

// const colors = ['#468b47','#90ee90', '#edf9eb'];
// const colors = ['#468b47', '#66b267', '#90ee90', '#aad4ab', '#cce5cc', '#edf9eb'];

const StackBarChartCard = () => {
  const chartOption = {
    title: {
      text: 'Subscribers on different Payment Tiers',
      left: 'left',
      textStyle: {
        color: '#468b47',
        lineHeight: 16,
      },
    },
    tooltip: {
      trigger: 'item',
    },

    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: ['Basic', 'Paid', 'Premium'],
        axisLabel: {
          color: '#468b47', // Green color for x-axis labels
          fontWeight: 'bold',
        },
        axisLine: {
          show: false, // Remove x-axis line
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color: '#468b47', // Green color for x-axis labels
        },
      },
    ],
    series: [
      {
        name: 'Active',
        type: 'bar',
        barGap: 0,
        // label: labelOption,
        emphasis: {
          focus: 'series',
        },
        data: [320, 1111, 400, 332, 301],
        itemStyle: {
          color: '#90ee90',
          borderColor: '#468b47',
          borderWidth: 1,
          borderRadius: 4,
        },
      },
      {
        name: 'Inactive',
        type: 'bar',
        // label: labelOption,
        emphasis: {
          focus: 'series',
        },
        data: [220, 182, 400, 191],
        itemStyle: {
          color: '#c4e9c4',
          borderColor: '#468b47',
          borderWidth: 1,
          borderRadius: 4,
        },
      },
      {
        name: 'Cancelled',
        type: 'bar',
        // label: labelOption,
        emphasis: {
          focus: 'series',
        },
        data: [150, 548, 232, 201],
        itemStyle: {
          color: '#468b47',
          borderColor: '#468b47',
          borderWidth: 1,
          borderRadius: 4,
        },
      },
    ],
  };

  return (
    <div
      style={{
        padding: '12px',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        border: '1px solid #fcbaba',
      }}
    >
      <select style={{ position: 'absolute', right: '12px', top: '12px' }}>
        <option value="option 1">option 1</option>
        <option value="option 2">option 2</option>
        <option value="option 3">option 3</option>
      </select>
      <ReactECharts
        notMerge={true}
        lazyUpdate={true}
        option={chartOption}
        style={{ height: '400px', minHeight: '300px' }}
      />
      <div
        style={{
          display: 'flex',
          gap: '12px',
          position: 'absolute',
          bottom: '12px',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <LegendItem color="#90ee90" text="Active" />
        <LegendItem color="#c4e9c4" text="Inactive" />
        <LegendItem color="#468b47" text="Cancelled" />
      </div>
    </div>
  );
};
export default StackBarChartCard;

const LegendItem = ({ color, text }) => {
  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flex: 'none' }}>
      <div style={{ backgroundColor: color, borderRadius: '9999px', height: '18px', width: '18px' }} />
      <span style={{ fontSize: '14px', marginTop: '2px' }}>{text}</span>
    </div>
  );
};
